import { render } from "./Queue.vue?vue&type=template&id=2f04c6de&scoped=true"
import script from "./Queue.vue?vue&type=script&lang=js"
export * from "./Queue.vue?vue&type=script&lang=js"

import "./Queue.vue?vue&type=style&index=0&id=2f04c6de&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f04c6de"]])

export default __exports__